"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { getOverlayPosition, useLayoutEffect } from "../utils";
import { useState } from "react";
import { useCallback } from "react";
import observeRect from "@reach/observe-rect";
const useOverlayPosition = (getOverlayPositionProps = {}) => {
  const [targetElement, setTargetElement] = useState(null);
  const [overlayElement, setOverlayElement] = useState(null);
  const targetRef = useCallback((node) => setTargetElement(node), []);
  const overlayRef = useCallback((node) => setOverlayElement(node), []);
  const [targetRect, setTargetRect] = useState();
  const [overlayRect, setOverlayRect] = useState();
  useLayoutEffect(() => {
    if (!targetElement || !overlayElement) {
      return;
    }
    const targetRectObserver = observeRect(targetElement, setTargetRect);
    const overlayRectObserver = observeRect(overlayElement, setOverlayRect);
    targetRectObserver.observe();
    overlayRectObserver.observe();
    return () => {
      targetRectObserver.unobserve();
      overlayRectObserver.unobserve();
    };
  }, [targetElement, overlayElement]);
  const overlayProps = getOverlayPosition(__spreadValues({
    targetRect,
    overlayRect
  }, getOverlayPositionProps));
  return {
    overlayProps: __spreadProps(__spreadValues({}, overlayProps), {
      width: targetRect ? targetRect.width : 0
    }),
    overlayRef,
    targetRef,
    targetElement
  };
};
export default useOverlayPosition;
